import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { resetPassword, clearAuthState } from "../redux/slices/authSlice";
import { Link, useNavigate } from "react-router-dom";
import logoiii from "../assets/logoiii.png";

const ResetPassword = () => {
  const [token, setToken] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const { loading, error, resetSuccess } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(resetPassword({ token, newPassword }));
  };

  // Redirigir después de éxito
  useEffect(() => {
    if (resetSuccess) {
      const timer = setTimeout(() => {
        navigate("/");
      }, 3000);
      
      return () => clearTimeout(timer);
    }
  }, [resetSuccess, navigate]);

  // Limpiar estado al desmontar
  useEffect(() => {
    return () => {
      dispatch(clearAuthState());
    };
  }, [dispatch]);

  return (
    <div className="bg-gray-900 text-white relative min-h-screen w-full flex items-center justify-center font-montserrat  overflow-hidden py-12 sm:py-20"
      style={{
        background: "linear-gradient(to bottom, #1a1a1a 0%, #0d0d0d 100%)",
        overflow: "hidden",
      }}>
      <div className="absolute inset-0 z-0" style={{
        backgroundImage: `repeating-linear-gradient(90deg, transparent 0px, transparent 20px, #000000 20px, #000000 40px, transparent 40px, transparent 100px)`,
        backgroundSize: "100px 100%",
        boxShadow: "inset 0 0 10px rgba(0,0,0,0.8)",
      }} />
      <div className="absolute inset-0 z-0" style={{
        backgroundImage: `repeating-linear-gradient(90deg, transparent 0px, transparent 20px, rgba(0,0,0,0.5) 20px, rgba(0,0,0,0.5) 40px, transparent 40px, transparent 100px)`,
        backgroundSize: "100px 100%",
        filter: "blur(3px)",
        transform: "translateX(2px)",
      }} />
      <div className="p-4 sm:p-6 md:p-8 rounded-2xl w-full max-w-lg relative z-10 mt-16 sm:mt-20 md:mt-5"
        style={{
          border: "2px solid rgba(255, 255, 255, 0.7)",
          boxShadow: "0 0 20px rgba(255, 255, 255, 0.2)",
          background: "rgba(0, 0, 0, 0)",
          backdropFilter: "blur(5px)",
        }}>
        <div className="flex items-center justify-center mb-6">
          <img src={logoiii} alt="Logo" className="w-16 h-16 sm:w-24 sm:h-24 object-contain mr-2" />
          <span className="text-white font-bold text-lg sm:text-xl">EPIC MOVIE</span>
        </div>

        {resetSuccess ? (
          <div className="bg-green-800 p-4 rounded-lg text-center">
            <div className="mx-auto h-12 w-12 rounded-full bg-green-700 flex items-center justify-center mb-4">
              <svg className="h-6 w-6 text-green-200" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h3 className="text-lg font-medium text-white">Contraseña actualizada</h3>
            <p className="mt-2 text-sm text-green-100">
              ¡Tu contraseña ha sido actualizada correctamente! Serás redirigido al inicio de sesión en unos segundos...
            </p>
            <div className="mt-4">
              <Link to="/login" className="underline text-blue-500">
                Ir al inicio de sesión ahora
              </Link>
            </div>
          </div>
        ) : (
          <>
            <div className="mb-4 p-3 bg-blue-900 text-blue-200 text-sm rounded">
              <p>Por favor, revisa tu correo electrónico para obtener el token de recuperación de contraseña. Una vez que lo recibas, ingrésalo aquí junto con tu nueva contraseña.</p>
            </div>

            {error && <div className="mb-4 p-2 bg-red-900 text-red-200 text-sm rounded">{error}</div>}

            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="mb-4">
                <label className="block text-sm font-medium text-white mb-2">Token de recuperación</label>
                <input
                  type="text"
                  className="w-full p-2 md:p-3 bg-transparent border border-white/30 rounded-md text-white"
                  placeholder="Ingresa el token recibido por correo"
                  value={token}
                  onChange={(e) => setToken(e.target.value)}
                  required
                />
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium text-white mb-2">Nueva contraseña</label>
                <input
                  type="password"
                  className="w-full p-2 md:p-3 bg-transparent border border-white/30 rounded-md text-white"
                  placeholder="Nueva contraseña"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                  autoComplete="new-password"
                />
              </div>

              <button
                type="submit"
                className="w-full mt-6 py-2 md:py-3 px-6 bg-yellow-400 text-black font-medium rounded-full transition-all duration-300 ease-in-out hover:bg-yellow-500 focus:outline-none focus:ring-4 focus:ring-yellow-300 focus:ring-opacity-50"
              >
                {loading ? "Procesando..." : "CAMBIAR CONTRASEÑA"}
              </button>
            </form>
          </>
        )}

        <p className="mt-4 text-center text-white">
          ¿Recordaste tu contraseña? <Link to="/" className="underline text-blue-500">Inicia sesión aquí</Link>
        </p>
      </div>
    </div>
  );
};

export default ResetPassword;

// import React, { useState } from 'react';
// import axios from 'axios';
// import { Link, useNavigate } from 'react-router-dom';
// import logoiii from "../assets/logoiii.png";

// const ResetPassword = () => {
//   const [token, setToken] = useState('');
//   const [newPassword, setNewPassword] = useState('');
//   const [message, setMessage] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const [success, setSuccess] = useState(false);
//   const navigate = useNavigate();

//   const API_URL = process.env.REACT_APP_API_URL;

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setError('');

//     try {
//       await axios.post(`${API_URL}/api/v1/auth/reset-password`, {
//         token,
//         newPassword
//       });

//       setSuccess(true);
//       setMessage('¡Tu contraseña ha sido actualizada correctamente!');
//       setTimeout(() => navigate('/'), 3000);
//     } catch (err) {
//       setError(err.response?.data?.message || 'Ocurrió un error al cambiar la contraseña');
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="flex flex-col items-center min-h-screen justify-center bg-black">
//       <img src={logoiii} alt="Logo de EPICMOVIE" className="w-24 h-24 mb-1" />
//       <h1 className="text-5xl font-bold text-white text-center drop-shadow-[0_0_10px_rgba(173,216,230,0.8)] shadow-lg font-montserrat">
//         EPIC
//       </h1>
//       <h1 className="text-5xl font-bold text-white text-center drop-shadow-[0_0_10px_rgba(173,216,230,0.8)] shadow-lg font-montserrat mb-5">
//         MOVIE
//       </h1>

//       {success ? (
//         <div className="bg-gray-800 p-8 rounded-lg shadow-md w-full max-w-sm text-center">
//           <div className="mx-auto h-12 w-12 rounded-full bg-green-700 flex items-center justify-center mb-4">
//             <svg className="h-6 w-6 text-green-200" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
//             </svg>
//           </div>
//           <h3 className="text-lg font-medium text-white">Contraseña actualizada</h3>
//           <p className="mt-2 text-sm text-gray-300">
//             {message} Serás redirigido al inicio de sesión en unos segundos...
//           </p>
//           <div className="mt-4">
//             <Link to="/" className="underline text-blue-500">
//               Ir al inicio de sesión ahora
//             </Link>
//           </div>
//         </div>
//       ) : (
//         <form 
//           onSubmit={handleSubmit}
//           className="bg-gray-800 p-8 rounded-lg shadow-md w-full max-w-sm"
//         >
//           <div className="mb-4 p-3 bg-blue-900 text-blue-200 text-sm rounded">
//             <p>Por favor, revisa tu correo electrónico para obtener el token de recuperación de contraseña. Una vez que lo recibas, ingrésalo aquí junto con tu nueva contraseña.</p>
//           </div>

//           {error && (
//             <div className="mb-4 p-2 bg-red-900 text-red-200 text-sm rounded">
//               {error}
//             </div>
//           )}

//           <div className="mb-4">
//             <label htmlFor="token" className="block text-sm font-medium text-gray-300">
//               Token de recuperación
//             </label>
//             <input
//               id="token"
//               name="token"
//               type="text"
//               className="mt-1 block w-full px-3 py-2 border border-gray-600 rounded-md shadow-sm bg-gray-700 text-white focus:outline-none focus:ring-blue-500 focus:border-blue-500"
//               placeholder="Ingresa el token recibido por correo"
//               value={token}
//               onChange={(e) => setToken(e.target.value)}
//             />
//           </div>

//           <div className="mb-6">
//             <label htmlFor="new-password" className="block text-sm font-medium text-gray-300">
//               Nueva contraseña
//             </label>
//             <input
//               id="new-password"
//               name="newPassword"
//               type="password"
//               autoComplete="new-password"
//               className="mt-1 block w-full px-3 py-2 border border-gray-600 rounded-md shadow-sm bg-gray-700 text-white focus:outline-none focus:ring-blue-500 focus:border-blue-500"
//               placeholder="Nueva contraseña"
//               value={newPassword}
//               onChange={(e) => setNewPassword(e.target.value)}
//             />
//           </div>

//           <button
//             type="submit"
//             disabled={loading}
//             className="w-full text-[#1a1f36]-600 py-3 px-6 border-2 border-[#1a1f36]-600 rounded-md transition-all duration-300 ease-in-out hover:bg-[#0f2027]-600 hover:text-white hover:border-[#1a1f36]-600 focus:outline-none focus:ring-4 focus:ring-[#0f2027]-500 focus:ring-opacity-50"
//           >
//             {loading ? 'Procesando...' : 'CAMBIAR CONTRASEÑA'}
//           </button>

//           <div className="flex items-center justify-center mt-4">
//             <Link to="/" className="underline text-blue-500">
//               Volver al inicio de sesión
//             </Link>
//           </div>
//         </form>
//       )}
//     </div>
//   );
// };

// export default ResetPassword;
